import Logo from '@/assets/images/adaptee-gastro-logo.svg'
import { ColorEnum } from '@/constants/color'
import SettingsIcon from '@/features/ui/icons/components/SettingsIcon'
import { Header } from '@react-navigation/elements'
import { Link } from 'expo-router'
import { FC } from 'react'
import { View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

const CompactDrawerContentHeader: FC = () => {
    const insets = useSafeAreaInsets()

    return (
        <View
            style={{
                justifyContent: 'center',
                height: insets.top + 56,
                paddingLeft: 16 + insets.left,
                paddingRight: 16 + insets.right,
                width: '100%',
            }}
        >
            <Header
                title=""
                headerTitle={() => <Logo height={31} width={89} />}
                headerTitleAlign="center"
                headerStyle={{
                    backgroundColor: ColorEnum.JET_900,
                    borderBottomWidth: 0,
                    elevation: 0,
                    shadowOpacity: 0,
                }}
                headerRight={() => (
                    <View style={{ marginLeft: 'auto' }}>
                        <Link href="/settings">
                            <SettingsIcon fill={ColorEnum.WHITE} />
                        </Link>
                    </View>
                )}
            />
        </View>
    )
}

export default CompactDrawerContentHeader
